import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
export function defined(d) {
  return d !== undefined && d !== null && !Number.isNaN(d);
}
/**
 * Sort data similar with Array.prototypo.sort.
 */
export var Sort = function Sort(options) {
  var callback = options.callback;
  return function (data) {
    return Array.isArray(data) ? _toConsumableArray(data).sort(callback) : data;
  };
};
Sort.props = {};